import { useRouter } from 'next/router'
import React, { Dispatch, createContext, useState } from 'react'
import dynamic from 'next/dynamic'
import RiskDisclosureModal from '../Stocks/FnO/Dashboard/RiskDisclosureModal'
import { HeaderShort } from './header/Header-short'
// import ShowLoginWidget from './LoginWidget/mountWidget'
import { MobileOverlayStateType } from './header/utils/types'
import Footer from '@/stories/components/Common/Footer/Footer'
import Header from '@/components/Common/header/header'
import { WithChildren } from '@/types/utilities'
import useIsInApp from '@/hooks/use-is-in-app'
import { useUpdateStagingEnv } from '@/revamp/reusable-hooks/use-update-staging-env/use-update-staging-env'
import { INDSTOCKS_HOST } from '@/root/constants/common'
import { isDSPIMFunnel, isEdelweissMFFunnel } from '@/root/utils/common/web/is-external-host'
// import { useFlyer } from '@/hooks/flyers/use-flyer'

const DisclaimerFooter = dynamic(
  () => import('@/components/Common/disclaimer-footer'),
  { ssr: false },
)

// const Flyers = dynamic(() => import('./Flyers/Flyers'))

const removedHeaderAndFooterOnPathnames = [
  'login',
  'iframe',
  'us-stocks-sem',
  'withdrawal-disposal-instructions-sbm',
  'kyc',
  'initiate-transaction',
  'rewards-alliance',
  'remit-nav',
  'confirm-remittance',
  'intermediatoryPayment',
  'page/lp',
  '/finzoom',
  'tpinflow',
  'all-in-one-app',
  'page/referral-404',
  'features/ads-homepage',
  'logout',
  'sso-handler',
  'features/us-homepage',
  'journey/2fa',
]

const logoOnlyHeaderRegexes = [
  /\/np-payment\/([a-z0-9]+-){4,5}([a-z0-9]+)/m, // np-payment/[basketId]
]

const logoOnlyHeaderSubStringIncludes = [
  'add-money',
  'transaction-status',
  'in_app_collect',
  'kyc/DIGIO_SUCCESS',
  // 'account-aggregator',
]

const showRiskDisclosureModalPathnames = [
  '/stocks',
  '/futures-and-options',
  '/futures-and-options/options',
  '/futures-and-options/futures',
  '/investments/stocks',
  '/investments/futures-and-options',
]

const removeOnlyFooter = ['/technicalchart', '/aa-onboarding']
const removeHeaderAndFooterIfPageProps = {
  inApp: true,
}

type PageProps = Record<string, unknown> & {
  inAppFromServer: boolean
  platform?: 'android' | 'ios'
  host: string
  stagingEnv?: string
}

const removeHeaderAndFooterEval = (pageProps: PageProps) => {
  const condition = Object.keys(pageProps).find(propName => {
    if (!pageProps[propName]) {
      return false
    }

    return pageProps[propName] === removeHeaderAndFooterIfPageProps[propName]
  })

  if (condition) {
    return true
  }

  return false
}

const shouldRemoveHeaderAndFooterForHost = (host: string) => {
  return isDSPIMFunnel(host) || isEdelweissMFFunnel(host)
}

export const SetOverlayContext = createContext<Dispatch<
  React.SetStateAction<MobileOverlayStateType>
> | null>(null)

const AppLayout = (props: WithChildren<PageProps>) => {
  const { children, ...rest } = props
  const isInMobile = rest.isInMobile as boolean | undefined
  const { inAppFromServer, platform } = rest

  const router = useRouter()
  const isInApp = useIsInApp(inAppFromServer)

  // const { data: flyerData } = useFlyer({
  //   isInMobile,
  // })

  const checkRouterPathnameIncludes = (pathstr: string) => {
    return router.asPath.includes(pathstr)
  }

  const initOverlayValue: MobileOverlayStateType = null

  const [overlay, setOverlay] =
    useState<MobileOverlayStateType>(initOverlayValue)

  let removeHeader = false
  let removeFooter = false
  let removeDisclaimer = false

  if (
    removedHeaderAndFooterOnPathnames.some(checkRouterPathnameIncludes) ||
    removeHeaderAndFooterEval(rest) ||
    shouldRemoveHeaderAndFooterForHost(props.host)
  ) {
    removeHeader = true
    removeFooter = true
  }

  const shouldShowLogoOnlyHeader =
    logoOnlyHeaderRegexes.some(regex => regex.test(router.asPath)) ||
    logoOnlyHeaderSubStringIncludes.some(checkRouterPathnameIncludes)

  if (shouldShowLogoOnlyHeader) {
    removeHeader = true
  }

  let showRiskDisclosureModal = false
  if (
    showRiskDisclosureModalPathnames.some(checkRouterPathnameIncludes) ||
    (router.pathname.includes('/dashboard') && props.host === INDSTOCKS_HOST)
  ) {
    showRiskDisclosureModal = true
  }

  if (isInApp) {
    removeHeader = true
    removeFooter = true
  }

  if (platform === 'android' || platform === 'ios') {
    removeHeader = true
    removeFooter = true
  }

  if (removeOnlyFooter.some(checkRouterPathnameIncludes)) {
    removeFooter = true
    removeDisclaimer = true
  }

  useUpdateStagingEnv(props.stagingEnv)
  const childernClass =
    router.asPath.split('?')[0] === '/page/indstocks-sip' ||
    router.asPath.includes('/stocks')
      ? 'min-h-screen'
      : ''

  return (
    <SetOverlayContext.Provider value={setOverlay}>
      <div className="relative">
        {!removeHeader && (
          <Header
            overlay={overlay}
            setOverlay={setOverlay}
            host={props.host}
            isInMobile={isInMobile}
          />
        )}
        {showRiskDisclosureModal && <RiskDisclosureModal />}
        {/* <TopGenericBanner referrer={rest.referrer} /> */}
        {shouldShowLogoOnlyHeader && (
          <HeaderShort disableLogoClick={false} host={props.host} />
        )}
        {/* {!isInApp && <ShowLoginWidget referrer={rest.referrer} />} */}

        <div className={`${childernClass} relative`}>{children}</div>
        {!removeDisclaimer && <DisclaimerFooter />}
        {!removeFooter && <Footer host={props.host} isInMobile={isInMobile} />}
        {/* <ValuePropAppInstallSticky /> */}
      </div>
      {/* {flyerData && <Flyers flyerData={flyerData} isMobile={isInMobile} />} */}
    </SetOverlayContext.Provider>
  )
}

export default AppLayout
